<template>
  <plus-clinic-settings v-if="clinicUser" ref="clinicSetting"/>
  <doctor-setting-container v-else/>
</template>

<script>
import { mapGetters } from "vuex";
import PlusClinicSettings from './PlusClinicSettings';
import DoctorSettingContainer from "@/pages/settings/doctor/DoctorSettingContainer.vue";

export default {
  name: "index",

  components: {DoctorSettingContainer, PlusClinicSettings},

  computed: {
    ...mapGetters([
      'clinicUser'
    ]),
  },

  beforeRouteLeave (to, from, next) {
    if (this.$refs.clinicSetting && this.$refs.clinicSetting.isEdit) {
      this.$refs.clinicSetting.showNotSaveAlert()
      next(false)
    } else {
      next()
    }
  }
}
</script>

<style scoped>

</style>